import { render } from "./forbidden.vue?vue&type=template&id=6a2b3e66&scoped=true"
import script from "./forbidden.vue?vue&type=script&lang=js"
export * from "./forbidden.vue?vue&type=script&lang=js"

import "./forbidden.vue?vue&type=style&index=0&id=6a2b3e66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2b3e66"]])

export default __exports__